module.exports = __webpack_public_path__ + "static/media/LinkedinIcon.e66a5ec6.png";